//const BASE_URL = 'https://13.232.52.232:5000';
// const BASE_URL = 'http://10.50.72.59:5000';
const BASE_URL = 'https://back.aisana.net';
// const BASE_URL = 'https://prediction.aisana.net:5000';
export default BASE_URL;
